import * as actions from "./actions"
import reducer from "./reducer"
import saga from "./saga"
import * as selectors from "./selectors"

const name = `applications`
export { name, actions, reducer, selectors, saga }
